module.exports = (() => {
	const env = document.location.hostname.split('.').reverse()[2] ?? 'dev';
	switch (env) {
		case 'prod':
		case 'app':
			return {
				ENV: 'production',
				URL_API: 'https://sdybackend.app.sidely.app',
				URL_API_BUILDER: 'https://form.app.sidely.app',
				URL_FOUNDATION: 'https://foundation.app.sidely.app',
				URL_FOUNDATION_WS: 'wss://foundation.app.sidely.app/ws/',
				URL_CERBERUS: 'https://cerberus.app.sidely.app',
				URL_JANUS: 'https://janus.app.sidely.app',
				URL_ALEXANDRIA: 'https://alexandria.app.sidely.app',
				HUBSPOT_CLIENT_ID: 'fea77b7e-36ce-42ec-9e3c-6064eff205b2',
				GOOGLE_CLIENT_ID: '564137750026-dd20p1qnicsirnrtjalrdtng5fb5725c.apps.googleusercontent.com',
				OUTLOOK_CALENDAR_CLIENT_ID: '206d45f4-9bfa-4866-915e-d229b56d242d',
				SENTRY_DSN:
				'https://aee4c2334cc0568a05d9d11bda2d697e@o4508693982674944.ingest.de.sentry.io/4508754672353360'
			};
		case 'edge':
			return {
				ENV: 'edge',
				URL_API: 'https://sdybackend.edge.sidely.app',
				URL_API_BUILDER: 'https://form.edge.sidely.app',
				URL_FOUNDATION: 'https://foundation.edge.sidely.app',
				URL_FOUNDATION_WS: 'wss://foundation.edge.sidely.app/ws/',
				URL_CERBERUS: 'https://cerberus.edge.sidely.app',
				URL_JANUS: 'https://janus.edge.sidely.app',
				URL_ALEXANDRIA: 'https://alexandria.edge.sidely.app',
				HUBSPOT_CLIENT_ID: '7f820813-754a-42c8-916f-59fb89651e25',
				GOOGLE_CLIENT_ID: '564137750026-m27bq8bj9g0rtujkbn8u8auisktt7bvq.apps.googleusercontent.com',
				OUTLOOK_CALENDAR_CLIENT_ID: 'c30d37ef-6418-40bd-a63f-d1a9534b7144',
				SENTRY_DSN:
				'https://aee4c2334cc0568a05d9d11bda2d697e@o4508693982674944.ingest.de.sentry.io/4508754672353360'
			};
		default:
			return {
				ENV: 'development',
				URL_API: process.env.URL_API || 'http://localhost:1515',
				URL_API_BUILDER: process.env.URL_API_BUILDER || 'http://localhost',
				URL_FOUNDATION: process.env.URL_FOUNDATION || 'http://localhost:1515',
				URL_FOUNDATION_WS: process.env.URL_FOUNDATION_WS || 'ws://localhost:1515/ws/',
				URL_CERBERUS: process.env.URL_CERBERUS || 'http://localhost:1792',
				URL_JANUS: process.env.URL_JANUS || 'http://localhost:1805',
				URL_ALEXANDRIA: process.env.URL_ALEXANDRIA || 'http://localhost',
				HUBSPOT_CLIENT_ID: '7f820813-754a-42c8-916f-59fb89651e25',
				GOOGLE_CLIENT_ID: '564137750026-lp81duqfmd7hfb05jm7no2dn9ku8hg6a.apps.googleusercontent.com',
				OUTLOOK_CALENDAR_CLIENT_ID: 'c30d37ef-6418-40bd-a63f-d1a9534b7144',
				SENTRY_DSN: process.env.SENTRY_DSN || ''
			};
	}
})();
